import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {DialogRef, DIALOG_DATA} from '@angular/cdk/dialog';
import {SelectOption} from 'libs/shared/ui/src/lib/models/select-option.model';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DialogComponent} from 'libs/shared/ui/src/lib/components/dialog/dialog.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, DialogComponent],
    templateUrl: './institution-change-modal.component.html',
    styleUrls: ['./institution-change-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstitutionChangeModalComponent {
    selectedId: string;

    constructor(
        private dialogRef: DialogRef<string, InstitutionChangeModalComponent>,
        @Inject(DIALOG_DATA) public data: InstitutionChangeModalData
    ) {
        this.selectedId = data.selectedId;
    }

    onSave(): void {
        this.dialogRef.close(this.selectedId);
    }

    onClose(): void {
        this.dialogRef.close();
    }
}

export interface InstitutionChangeModalData {
    institutions: SelectOption[];
    selectedId: string;
}
